import { TextField } from '@mui/material';
import { motion } from 'framer-motion';
import { Fragment } from 'react';
import { PatternFormat } from 'react-number-format';
import formLocalizedHelperText from 'utils/formLocalizedHelperText';
import { fadeUp } from 'utils/motion';

const FormPhoneField2 = ({
  delay = 0,
  duration = 0.5,
  fieldName,
  formik,
  label,
  onKeyDown = () => {},
  readOnly = false,
  disabled = false,
  variant = 'outlined',
  autocomplete = 'off',
  onBlur,
  ...props
}) => {
  const getFieldValue = () => {
    if (fieldName && fieldName.includes('.')) {
      let a = fieldName.split('.');
      let b = formik.values;
      for (let i = 0; i < a.length; i++) {
        b = b?.[a?.[i]];
      }
      return b;
    }
    return formik.values?.[fieldName] || '';
  };

  const getFieldValidation = (formikF) => {
    if (fieldName && fieldName.includes('.')) {
      let a = fieldName.split('.');
      let b = formik[formikF];
      for (let i = 0; i < a.length; i++) {
        if (b?.[a?.[i]]) {
          b = b?.[a?.[i]];
        } else {
          b = false;
        }
      }
      return b;
    }
    return formik?.[formikF]?.[fieldName] || '';
  };

  return (
    <Fragment>
      {formik && formik.values && formik.touched && formik.errors && (
        <PatternFormat
          id={fieldName}
          name={fieldName}
          label={label}
          value={getFieldValue()}
          delay={delay}
          onChange={(event) => {
            formik.setFieldValue(fieldName, event.target.value, true);
          }}
          error={
            getFieldValidation('touched') &&
            Boolean(getFieldValidation('errors'))
          }
          helperText={
            getFieldValidation('touched') &&
            formLocalizedHelperText(getFieldValidation('errors'))
          }
          component={motion.div}
          variants={fadeUp(30, 'tween', delay, duration)}
          initial='hidden'
          animate='show'
          viewport={{ once: true, amount: 0.25 }}
          color='formColor'
          variant={variant}
          fullWidth
          customInput={TextField}
          InputProps={{
            readOnly: readOnly,
            disabled: disabled,
          }}
          onKeyDown={onKeyDown}
          format='+998#########'
          onBlur={onBlur}
          autocomplete={autocomplete}
          {...props}
        />
      )}
    </Fragment>
  );
};

export default FormPhoneField2;
